
export class Contact {
  public last_name:string="";
  public first_name:string="";
  public email:string="";
  public destinataire:string ="-1";
  public message:string="";
  public OrgaMail:string;
  public lang:string;

  constructor() {}

}
